import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import PageView from '@/components/PageView/index.vue'
import Layout from '@/layout/index.vue'
import { ADMIN, STUDENT, TEACHER } from '@/utils/roles'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location
  ).catch(
    (error) =>
      error
  )
}

Vue.use(VueRouter)

export const routesForNewStudent = {
  path: '/admin',
  component: Layout,
  meta: {
    requiresAuth: true,
    allowedRoles: [STUDENT]
  },
  children: [
    {
      path: '/student/query',
      component: PageView,
      meta: {
        name: '信息查询',
        requiresAuth: true,
        role: STUDENT,
        allowedRoles: [STUDENT]
      },
      children: [
        {
          path: '/student/query/admission',
          meta: {
            name: '录取信息',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import('@/views/query/newStudentInfo/index.vue')
        },
        {
          path: '/student/query/announcementInfo',
          meta: {
            name: '公告查询',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/announcementInfo/index.vue')
        },
        {
          path: '/student/query/fees',
          meta: {
            name: '缴费查询',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/pay_the_fees/index.vue')
        }
      ]
    },
    {
      path: '/student/transaction_apply',
      component: PageView,
      meta: {
        name: '事务申请',
        requiresAuth: true,
        role: STUDENT,
        allowedRoles: [STUDENT]
      },
      children: [
        {
          path: '/student/transaction_apply/change_major_name',
          meta: {
            name: '转专业申请',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/change_major_name.vue')
        }
      ]
    },
    {
      path: '/student/message_manage',
      component: PageView,
      meta: {
        name: '消息管理',
        requiresAuth: true,
        role: STUDENT,
        allowedRoles: [STUDENT]
      },
      children: [
        {
          path: '/student/message_manage/download_message',
          meta: {
            name: '下载文件消息',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import('@/views/student/message_manage/download_message.vue')
        }
      ]
    }
  ]
}

export const admin = {
  path: '/admin',
  component: Layout,
  meta: {
    requiresAuth: true,
    allowedRoles: [STUDENT, TEACHER]
  },
  children: [
    {
      path: '/student/query',
      component: PageView,
      meta: {
        name: '信息查询',
        requiresAuth: true,
        role: STUDENT,
        allowedRoles: [STUDENT]
      },
      children: [
        {
          path: '/student/query/status',
          meta: {
            name: '学籍查询',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/student_status/index.vue')
        },
        {
          path: '/student/query/fees',
          meta: {
            name: '缴费查询',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/pay_the_fees/index.vue')
        },
        {
          path: '/student/query/score',
          meta: {
            name: '成绩查询',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/score/index.vue')
        }
      ]
    },
    // ============ 已屏蔽:教师侧"信息查询"菜单(学生查询/班级查询)不对教师开放 ============
    // {
    //   path: '/teacher/query',
    //   component: PageView,
    //   meta: {
    //     name: '信息查询',
    //     requiresAuth: true,
    //     role: TEACHER,
    //     allowedRoles: [TEACHER]
    //   },
    //   children: [
    //     {
    //       path: '/teacher/query/student',
    //       meta: {
    //         name: '学生查询',
    //         requiresAuth: true,
    //         allowedRoles: [TEACHER]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/student/index.vue')
    //     },
    //     {
    //       path: '/teacher/query/classes',
    //       meta: {
    //         name: '班级查询',
    //         requiresAuth: true,
    //         allowedRoles: [TEACHER]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/query/classes/index.vue')
    //     }
    //   ]
    // },
    {
      path: '/student',
      component: PageView,
      meta: {
        requiresAuth: true,
        name: '课程学习',
        role: STUDENT,
        allowedRoles: [STUDENT]
      },
      redirect: '/student/query/status',
      children: [
        {
          path: '/student/courses',
          meta: {
            name: '课程详情',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_courses' */'@/views/student/live/courses.vue')
        },
        {
          path: '/student/live-playback',
          meta: {
            name: '课程回放',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/live/playback.vue')
        },
        {
          path: '/student/learning',
          meta: {
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/live/learning.vue')
        },
        {
          path: '/student/live',
          meta: {
            name: '课程学习',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/live/index.vue')
        },
        {
          path: '/student/plan',
          meta: {
            name: '课程教学计划',
            requiresAuth: true,
            allowedRoles: [STUDENT]
          },
          component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/plan/index.vue')
        }
      ]
    },
    // {
    //   path: '/student/transaction_apply',
    //   component: PageView,
    //   meta: {
    //     name: '事务申请',
    //     requiresAuth: true,
    //     role: STUDENT,
    //     allowedRoles: [STUDENT]
    //   },
    //   children: [
    //     {
    //       path: '/student/transaction_apply/change_major_name',
    //       meta: {
    //         name: '转专业申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/change_major_name.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/suspension',
    //       meta: {
    //         name: '休学申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/suspension.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/resumption',
    //       meta: {
    //         name: '复学申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/resumption.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/dropout',
    //       meta: {
    //         name: '退学申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/dropout.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/retention',
    //       meta: {
    //         name: '留级申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/retention.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/graduation_approval',
    //       meta: {
    //         name: '毕业审核查询',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/graduation_approval.vue')
    //     },
    //     {
    //       path: '/student/transaction_apply/apply_graduation_merit',
    //       meta: {
    //         name: '毕业评优申请',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import(/* webpackChunkName: 'student_index' */'@/views/student/transaction_apply/apply_graduation_merit.vue')
    //     }
    //   ]
    // },
    // {
    //   path: '/student/message_manage',
    //   component: PageView,
    //   meta: {
    //     name: '消息管理',
    //     requiresAuth: true,
    //     role: STUDENT,
    //     allowedRoles: [STUDENT]
    //   },
    //   children: [
    //     {
    //       path: '/student/message_manage/download_message',
    //       meta: {
    //         name: '下载文件消息',
    //         requiresAuth: true,
    //         allowedRoles: [STUDENT]
    //       },
    //       component: () => import('@/views/student/message_manage/download_message.vue')
    //     }
    //   ]
    // },
    {
      path: '/teacher',
      component: PageView,
      meta: {
        requiresAuth: true,
        name: '教学管理',
        role: TEACHER,
        allowedRoles: [TEACHER]
      },
      redirect: '/teacher/live',
      children: [
        {
          path: '/teacher/courses',
          meta: {
            name: '课程详情',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-courses' */'@/views/teacher/live/courses.vue')
        },
        {
          path: '/teacher/live',
          meta: {
            name: '课程教学',
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-live_index' */'@/views/teacher/live/index.vue')
        },
        {
          path: '/teacher/teaching',
          meta: {
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-courses' */'@/views/teacher/live/teaching.vue')
        },
        {
          path: '/teacher/live-detail',
          meta: {
            name: '课程直播教学详情',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-live_index' */'@/views/teacher/live/detail.vue')
        },
        {
          path: '/teacher/plan',
          meta: {
            name: '课程教学计划',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-plan_index' */'@/views/teacher/plan/index.vue')
        },
        {
          path: '/teacher/statistics',
          meta: {
            name: '课程教学统计',
            hideMenu: true,
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import(/* webpackChunkName: 'teacher-statistics_index' */'@/views/teacher/statistics/index.vue')
        }
      ]
    },
    {
      path: '/teacher/message_manage',
      component: PageView,
      meta: {
        name: '消息管理',
        requiresAuth: true,
        role: TEACHER,
        allowedRoles: [TEACHER]
      },
      children: [
        {
          path: '/teacher/message_manage/download_message',
          meta: {
            name: '下载文件消息',
            requiresAuth: true,
            allowedRoles: [TEACHER]
          },
          component: () => import('@/views/teacher/massage_manage/download_message.vue')
        }
      ]
    }
  ]
}

// ============ 公开路由白名单 ============
// 只有这些路由不需要登录就能访问;其他所有路由默认拒绝
const WHITE_LIST = ['/login', '/error-page', '/404']

// 路由规则
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: 'login' */'@/views/login/index'),
    meta: {
      // 显式标记为公开页面,不需要鉴权
      isPublic: true
    }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: 'back_manage_index' */'@/views/back_manage/index'),
    meta: {
      requiresAuth: true,
      allowedRoles: [ADMIN]
    },
    redirect: '/home',
    children: [
      {
        path: 'home',
        meta: {
          name: 'back_home',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '首页'
        },
        component: () => import(/* webpackChunkName: 'home' */'@/views/back_manage/home')
      },
      {
        path: 'teaching_point_info',
        meta: {
          name: 'teaching_point_info',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '教学点信息'
        },
        component: () => import('@/views/back_manage/platform_base_info_manage/teaching_point_info.vue')
      },
      {
        path: 'second_college_info',
        meta: {
          name: 'second_college_info',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '二级学院信息'
        },
        component: () => import('@/views/back_manage/platform_base_info_manage/second_college_info.vue')
      },
      {
        path: 'platform_base_info_manage/platform_user_manage/platform_user_info',
        meta: {
          name: 'back_user_info',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '平台用户信息'
        },
        component: () => import(/* webpackChunkName: 'platform_user_info' */'@/views/back_manage/platform_base_info_manage/platform_user_manage/platform_user_info.vue')
      },
      {
        path: 'platform_base_info_manage/platform_user_manage/platform_log_manage',
        meta: {
          name: 'back_log_msg',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '后台日志信息'
        },
        component: () => import(/* webpackChunkName: 'platform_log_manage' */'@/views/back_manage/platform_base_info_manage/platform_user_manage/platform_user_log.vue')
      },
      {
        path: 'teaching_manage/online_teaching_manage/online_courses_info',
        meta: {
          name: 'online_teaching_info_view',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '机考信息管理'
        },
        component: () => import(/* webpackChunkName: 'online_courses_info' */'@/views/back_manage/teaching_manage/online_teaching_manage/online_courses_info')
      },
      {
        path: 'teaching_manage/online_teaching_manage/student_online_learning_records',
        meta: {
          name: 'student_online_learning_records',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '学生在线学习记录'
        },
        component: () => import(/* webpackChunkName: 'student_online_learning_records' */'@/views/back_manage/teaching_manage/online_teaching_manage/student_online_learning_records')
      },
      {
        path: 'teaching_manage/online_teaching_manage/teachers_teaching_records',
        meta: {
          name: 'teachers_teaching_records',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '教师在线教学记录'
        },
        component: () => import(/* webpackChunkName: 'teachers_teaching_records' */'@/views/back_manage/teaching_manage/online_teaching_manage/teachers_teaching_records')
      },
      {
        path: 'teaching_manage/online_teaching_manage/teacher_information_manage',
        meta: {
          name: 'teacher_information_manage',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '授课老师管理'
        },
        component: () => import(/* webpackChunkName: 'teacher_information_manage' */'@/views/back_manage/teaching_manage/online_teaching_manage/teacher_information_manage')
      },
      {
        path: 'teaching_manage/online_teaching_manage/schedule',
        meta: {
          name: 'scheduleManage',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '排课表明细'
        },
        component: () => import(/* webpackChunkName: 'schedule_manage' */'@/views/back_manage/teaching_manage/online_teaching_manage/schedule')
      },
      {
        path: 'teaching_manage/online_teaching_manage/schedule_course',
        meta: {
          name: 'schedule_course',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '排课表课程管理'
        },
        component: () => import(/* webpackChunkName: 'schedule_course' */'@/views/back_manage/teaching_manage/online_teaching_manage/schedule_course')
      },
      {
        path: 'teaching_manage/online_teaching_manage/comprehensive_course_manage',
        meta: {
          name: 'comprehensive_course_manage',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '综合课程管理'
        },
        component: () => import(/* webpackChunkName: 'schedule_course' */'@/views/back_manage/teaching_manage/online_teaching_manage/comprehensive_course_manage')
      },
      {
        path: 'teaching_manage/teaching_plans_manage/teaching_plan_query',
        meta: {
          name: 'teaching_plan_query',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '教学计划查询'
        },
        component: () => import(/* webpackChunkName: 'teaching_plan_query' */'@/views/back_manage/teaching_manage/teaching_plans_manage/teaching_plan_query')
      },
      {
        path: 'teacher_database',
        meta: {
          name: 'teacher_database',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '师资库管理'
        },
        component: () => import(/* webpackChunkName: 'teaching_plan_query' */'@/views/back_manage/teaching_manage/teacher_database')
      },
      {
        path: 'enrollment_plan',
        meta: {
          name: 'enrollment_plan',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '招生计划'
        },
        component: () => import(/* webpackChunkName: 'teaching_plan_query' */'@/views/back_manage/enrollment_management/enrollment_plan')
      },
      {
        path: 'student_info_search/payment_information_inquiry',
        meta: {
          name: 'payment_information_inquiry',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '缴费信息查询'
        },
        component: () => import(/* webpackChunkName: 'payment_information_inquiry' */'@/views/back_manage/student_info_search/payment_information_inquiry')
      },
      {
        path: 'student_info_search/new_student_payment_information',
        meta: {
          name: 'payment_information_inquiry',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '新生缴费信息查询'
        },
        component: () => import(/* webpackChunkName: 'payment_information_inquiry' */'@/views/back_manage/student_info_search/new_student_payment_information')
      },
      {
        path: 'student_info_search/registered_student_search',
        meta: {
          name: 'registered_student_search',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '在籍学生查询'
        },
        component: () => import(/* webpackChunkName: 'registered_student_search' */'@/views/back_manage/student_info_search/registered_student_search')
      },
      {
        path: 'student_info/new_stdent_info',
        meta: {
          name: 'new_stdent_info',
          title: '新生信息查询',
          requiresAuth: true,
          allowedRoles: [ADMIN]
        },
        component: () => import('@/views/back_manage/student_info_search/new_studentInfo.vue')
      },
      {
        path: 'student_info_search/score_information_query',
        meta: {
          name: 'score_information_query',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '成绩信息查询'
        },
        component: () => import(/* webpackChunkName: 'score_information_query' */'@/views/back_manage/student_info_search/score_information_query')
      },
      {
        path: 'student_exemption_approval',
        meta: {
          name: 'student_exemption_approval',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '学生免修审批、查询'
        },
        component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/student_studies_manage/student_exemption_approval')
      },
      {
        path: 'student_retake_approval',
        meta: {
          name: 'student_retake_approval',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '学生重修审批、查询'
        },
        component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/student_studies_manage/student_retake_approval')
      },
      {
        path: 'degree_approval',
        meta: {
          name: 'degree_approval',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '学位审批、查询'
        },
        component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/student_studies_manage/degree_approval')
      },
      {
        path: 'graduation_approval',
        meta: {
          name: 'graduation_approval',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '毕业审批、查询'
        },
        component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/student_studies_manage/graduation_approval')
      },
      {
        path: 'student_evaluation',
        meta: {
          name: 'student_evaluation',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '学生评优、查询'
        },
        component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/student_studies_manage/student_evaluation')
      },
      {
        path: 'class_information_management/class_information_query',
        meta: {
          name: 'class_information_query',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '班级信息查询'
        },
        component: () => import(/* webpackChunkName: 'class_information_query' */'@/views/back_manage/class_information_management/class_information_query')
      },
      {
        path: 'class_information_management/teaching_class_query',
        meta: {
          name: 'teaching_class_query',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '教学班级查询'
        },
        component: () => import(/* webpackChunkName: 'teaching_class_query' */'@/views/back_manage/class_information_management/teaching_class_query')
      },
      {
        path: '/batch_data_process',
        meta: {
          name: 'batch_data_process',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '批量数据处理'
        },
        component: () => import(/* webpackChunkName: 'batch_data_process' */ '@/views/back_manage/batch_data_process/index'),
        redirect: '/batch_data_process/batch_data_import',
        children: [
          {
            path: 'batch_data_import',
            meta: {
              name: 'batch_data_import',
              requiresAuth: true,
              allowedRoles: [ADMIN],
              title: '批量数据导入'
            },
            component: () => import(/* webpackChunkName: 'batch_data_import' */ '@/views/back_manage/batch_data_process/batch_data_import')
          },
          {
            path: 'data_synchronize',
            meta: {
              name: 'data_synchronize',
              requiresAuth: true,
              allowedRoles: [ADMIN],
              title: '新旧系统数据同步'
            },
            component: () => import(/* webpackChunkName: 'data_synchronize' */ '@/views/back_manage/batch_data_process/data_synchronize')
          }
        ]
      },
      {
        path: 'data_view/platform_basic_data',
        meta: {
          name: 'platform_basic_data',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '平台基础数据展示'
        },
        component: () => import(/* webpackChunkName: 'platform_basic_data' */'@/views/back_manage/data_view/platform_basic_data')
      },
      {
        path: 'data_view/course_schedule_data',
        meta: {
          name: 'course_schedule_data',
          requiresAuth: true,
          allowedRoles: [ADMIN],
          title: '课程教学数据展示'
        },
        component: () => import(/* webpackChunkName: 'course_schedule_data' */'@/views/back_manage/data_view/course_schedule_data')
      },
      // 平台消息管理
      {
        path: '/message_manage',
        name: 'message_manage',
        meta: {
          requiresAuth: true,
          allowedRoles: [ADMIN]
        },
        component: () => import(/* webpackChunkName: 'message_manage' */ '@/views/back_manage/message_manage/index'),
        redirect: '/message_manage/announcement_manage',
        children: [
          {
            path: 'announcement_manage',
            meta: {
              name: 'announcement_manage',
              requiresAuth: true,
              allowedRoles: [ADMIN],
              title: '公告管理'
            },
            component: () => import(/* webpackChunkName: 'announcement_manage' */ '@/views/back_manage/message_manage/announcement_manage')
          },
          {
            path: 'platform_message_manage',
            meta: {
              name: 'platform_message_manage',
              requiresAuth: true,
              allowedRoles: [ADMIN],
              title: '平台消息管理'
            },
            component: () => import(/* webpackChunkName: 'platform_message_manage' */ '@/views/back_manage/message_manage/platform_message_manage')
          },
          {
            path: 'platform_user_logs',
            meta: {
              name: 'platform_user_logs',
              requiresAuth: true,
              allowedRoles: [ADMIN],
              title: '平台用户日志管理'
            },
            component: () => import(/* webpackChunkName: 'platform_user_logs' */ '@/views/back_manage/message_manage/platform_user_logs')
          }
        ]
      }
    ]
  },
  admin,
  routesForNewStudent,
  {
    path: '/student/learning/video',
    meta: {
      hideMenu: true,
      requiresAuth: true,
      allowedRoles: [STUDENT]
    },
    component: () => import('@/views/student/live/video.vue')
  },
  {
    path: '/error-page',
    name: 'error-page',
    component: () => import(/* webpackChunkName: 'error-page' */'@/views/error-page/index'),
    meta: {
      isPublic: true
    }
  },
  {
    // 通配符路由必须放最后,匹配所有未声明的路径
    path: '*',
    redirect: '/error-page'
  }
]

const router = new VueRouter({
  routes
})

function isRouteAccessible (routes, path) {
  for (const route of routes) {
    if (path === route.path) {
      return true
    }
    if (route.children && route.children.length > 0 && isRouteAccessible(route.children, path)) {
      return true
    }
  }
  return false
}

// ============ 工具函数:获取当前用户用于权限校验的角色列表 ============
// 与后端 /platform-user/login 返回的 userInfo 字段对齐:
//   - roleName:        归一化值("管理员" / "教师" / "学生"),路由 allowedRoles 实际匹配的字段
//   - detailRoleName:  真实角色(如 "二级学院管理员"),用于后续细粒度控制
//   - allRoleNameList: 多角色场景的完整列表(如 ["二级学院管理员", "教学督导"])
function getUserRoles (user) {
  if (!user) return []

  const roles = []

  // 主字段:归一化后的 roleName(对应 roles.js 里的 ADMIN/TEACHER/STUDENT)
  if (user.roleName) {
    roles.push(user.roleName)
  }

  // 备用字段:真实角色名(将来路由可用具体角色细化控制)
  if (user.detailRoleName && !roles.includes(user.detailRoleName)) {
    roles.push(user.detailRoleName)
  }

  // 多角色支持:把 allRoleNameList 全部纳入
  if (Array.isArray(user.allRoleNameList)) {
    user.allRoleNameList.forEach(r => {
      if (r && !roles.includes(r)) roles.push(r)
    })
  }

  // 兼容老字段(如果有 roleList 也读)
  if (Array.isArray(user.roleList)) {
    user.roleList.forEach(r => {
      if (r && !roles.includes(r)) roles.push(r)
    })
  }

  return roles
}

// ============ 工具函数:在 matched 路由链中查找 allowedRoles ============
// 从最深的路由开始往上找,取最近一个声明了 allowedRoles 的祖先
function findRequiredRoles (matched) {
  for (let i = matched.length - 1; i >= 0; i--) {
    const meta = matched[i].meta
    if (meta && Array.isArray(meta.allowedRoles) && meta.allowedRoles.length > 0) {
      return meta.allowedRoles
    }
  }
  return null
}

// ============ 路由守卫(默认拒绝模式) ============
router.beforeEach((to, from, next) => {
  // 1. 公开页面(登录页、错误页)直接放行
  if (to.meta && to.meta.isPublic) {
    return next()
  }
  if (WHITE_LIST.includes(to.path)) {
    return next()
  }

  // 2. 获取登录用户信息
  const user = store.state.user
  const roleList = getUserRoles(user)

  // 3. 未登录或没有角色 → 一律踢回登录页
  //    注意:这里不再依赖 requiresAuth 字段,默认所有非白名单路由都要求登录
  if (!user || roleList.length === 0) {
    console.warn('[路由守卫] 未登录访问', to.path, ',跳转登录页')
    return next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
  }

  // 4. 新生隔离逻辑
  const isNewStudent = store.state.isNewStudent ? store.state.isNewStudent.isNewStudent : false
  const accessibleForNewStudent = isRouteAccessible(routesForNewStudent.children, to.path)
  if (isNewStudent && !accessibleForNewStudent) {
    return next('/student/query/admission')
  }

  // 5. 角色校验:查找路由链上最近声明的 allowedRoles
  const requiredRoles = findRequiredRoles(to.matched)

  if (requiredRoles) {
    // 路由声明了 allowedRoles → 用户必须至少有一个匹配的角色
    const hasPermission = roleList.some(r => requiredRoles.includes(r))
    if (!hasPermission) {
      console.warn('[路由守卫] 角色不匹配', to.path,
        '用户角色:', roleList, '需要角色:', requiredRoles)
      return next({ name: 'error-page' })
    }
  } else {
    // ⚠️ 关键:路由没声明 allowedRoles → 默认拒绝
    // 这条规则把所有"忘记加权限"的页面(包括 mock 数据页面)都拦下了
    console.warn('[路由守卫] 路由未声明 allowedRoles,默认拒绝:', to.path)
    return next({ name: 'error-page' })
  }

  // 6. 面包屑更新(保留原逻辑)
  if (to.meta && to.meta.name &&
        store.state.newBreadCrumb &&
        store.state.newBreadCrumb.breadcrumbs.filter(item => item.name === to.meta.name).length === 0) {
    store.commit('newBreadCrumb/setBreadcrumbs', {
      path: to.path,
      name: to.meta.title
    })
    store.commit('newBreadCrumb/setCurrentSelect', {
      path: to.path,
      name: to.meta.title
    })
  }

  next()
})

export default router
